import React from 'react'

const FaqSection = () => (
  <section className="text-gray-700 bg-gray-100" id="faq">
    <div className="container px-5 py-12 mx-auto lg:py-24">
      <h3 className="mb-10 text-3xl font-bold text-center">H&auml;ufig gestellte Fragen</h3>
      <div className="mx-auto lg:flex justify-evenly">
        <div className="lg:w-1/2">
          <div className="px-4 py-1 mb-8 bg-white rounded-2xl">
            <button
              className="flex items-center justify-between w-full py-1 cursor-pointer"
              data-toggle="collapsible"
              type="button"
            >
              <div className="text-sm font-bold leading-5 text-left">
                Wie funktioniert der Autoverkauf bei <span className="text-brand-fuchsia">autoverkaufen.de</span>?
              </div>
              <div className="text-lg font-bold leading-7 text-blue-500">+</div>
            </button>
            <div className="px-2 collapsible-content">
              <p className="mb-2">
                Im ersten Schritt f&uuml;hrst du unsere kostenlose Online-Bewertung durch und stellst uns erste wichtige
                Fahrzeugdaten zur Verf&uuml;gung. Anhand dieser Merkmale ermittelt unser umfangreicher Pricing-Algorithmus
                dann einen ersten Sch&auml;tzpreis, den du umgehend per E-Mail erh&auml;ltst. Um den endg&uuml;ltigen Bestpreis
                f&uuml;r dein Fahrzeug ermitteln zu k&ouml;nnen, ben&ouml;tigen unsere Experten noch einige weitere Informationen
                und Fotos. Auch diese kannst du ganz bequem von zu Hause aus &uuml;ber die Eingabemaske hochladen. Mit der
                Angabe weiterer Ausstattungsmerkmale hilfst du unseren Experten dabei, deinen individuellen Bestpreis zu
                ermitteln, der ganz genau auf dein Fahrzeug zugeschnitten ist. Nach der Berechnung erh&auml;ltst du deinen
                Bestpreis per E-Mail. Wenn du mit deinem Bestpreis einverstanden bist, hast du die M&ouml;glichkeit direkt in
                der E-Mail einen Termin an einem Ort deiner Wahl zu buchen. Dort gleicht einer unserer Mitarbeiter deine
                eingegebenen Fahrzeugdaten ab und du kannst dein Auto noch vor Ort verkaufen. Im Anschluss &uuml;berweisen wir
                dir den Verkaufspreis umgehend auf dein Bankkonto und melden dein Auto au&szlig;erdem kostenlos f&uuml;r dich ab.
              </p>
              <p className="text-brand-fuchsia">
                Bring zu deinem Abgabe-Termin unbedingt die Fahrzeugschl&uuml;ssel, den Fahrzeugschein und den Fahrzeugbrief
                mit. Entferne vor der Abgabe alle pers&ouml;nlichen Gegenst&auml;nde aus dem Fahrzeug.
              </p>
            </div>
          </div>

          <div className="px-4 py-1 mb-8 bg-white rounded-2xl">
            <button
              className="flex items-center justify-between w-full py-1 cursor-pointer"
              data-toggle="collapsible"
              type="button"
            >
              <div className="text-sm font-bold leading-5 text-left">
                Wie erfahre ich den aktuellen Wert meines Autos?
              </div>
              <div className="text-lg font-bold leading-7 text-blue-500">+</div>
            </button>
            <div className="px-2 collapsible-content">
              Im ersten Schritt stellst du uns erste Basisdaten zur Verf&uuml;gung. Anhand dieser Merkmale wird bereits ein
              erster Sch&auml;tzpreis errechnet, den du umgehend per E-Mail erh&auml;ltst. Im zweiten Schritt stellst du uns weitere
              relevante Informationen und Fotos zur Verf&uuml;gung. Daraus wird dein individueller Bestpreis ermittelt, den wir
              dir ebenfalls per E-Mail zusenden.
            </div>
          </div>

          <div className="px-4 py-1 mb-8 bg-white rounded-2xl">
            <button
              className="flex items-center justify-between w-full py-1 cursor-pointer"
              data-toggle="collapsible"
              type="button"
            >
              <div className="text-sm font-bold leading-5 text-left">Wie wird der Preis f&uuml;r mein Fahrzeug berechnet?</div>
              <div className="text-lg font-bold leading-7 text-blue-500">+</div>
            </button>
            <div className="px-2 collapsible-content">
              F&uuml;r unsere Bestpreisermittlung ber&uuml;cksichtigen wir eine Vielzahl von Faktoren. Unser Expertenteam greift
              auf einen gro&szlig;en Erfahrungsschatz zur&uuml;ck. Dabei unterst&uuml;tzen uns mehrere kompetente Partner wie bspw.
              DEKRA und mobile.de, die unseren Pricing-Algorithmus mit zus&auml;tzlichen Daten anreichern.
            </div>
          </div>

          <div className="px-4 py-1 mb-8 bg-white rounded-2xl">
            <button
              className="flex items-center justify-between w-full py-1 cursor-pointer"
              data-toggle="collapsible"
              type="button"
            >
              <div className="text-sm font-bold leading-5 text-left">
                Was ist der Unterschied zwischen Sch&auml;tzpreis und Bestpreis?
              </div>
              <div className="text-lg font-bold leading-7 text-blue-500">+</div>
            </button>
            <div className="px-2 collapsible-content">
              Der Sch&auml;tzpreis wird nur anhand weniger Fahrzeugmerkmale ermittelt, wobei wir zun&auml;chst von der
              Grundausstattung ausgehen. Dieser Preis stellt eine erste Einsch&auml;tzung deines Fahrzeugwertes dar. Mit der
              Angabe weiterer Ausstattungsmerkmale hilfst du uns dabei, einen individuellen Bestpreis zu ermitteln, der
              ganz genau auf dein Fahrzeug zugeschnitten ist. Dein finaler Bestpreis f&auml;llt &ndash; je nach zus&auml;tzlichen
              Ausstattungen &ndash; oft sogar h&ouml;her aus.
            </div>
          </div>

          <div className="px-4 py-1 mb-8 bg-white rounded-2xl">
            <button
              className="flex items-center justify-between w-full py-1 cursor-pointer"
              data-toggle="collapsible"
              type="button"
            >
              <div className="text-sm font-bold leading-5 text-left">Wie l&auml;uft der Verkauf ab?</div>
              <div className="text-lg font-bold leading-7 text-blue-500">+</div>
            </button>
            <div className="px-2 collapsible-content">
              Wenn du mit deinem Bestpreis einverstanden bist, kannst du im Anschluss einen Abholtermin bei dir zu Hause
              oder beispielsweise am Arbeitsplatz buchen. Vor Ort gleicht einer unserer Experten deine eingegebenen
              Fahrzeugdaten ab und du kannst dein Auto direkt verkaufen. Wir &uuml;berweisen das Geld umgehend auf dein
              Bankkonto und melden dein Auto kostenlos f&uuml;r dich ab.
            </div>
          </div>

          <div className="flex justify-center lg:justify-end">
            <a href="#faq" className="px-8 py-2 font-bold text-center text-white rounded-full bg-azure hover:bg-azure-dark">
              Weitere Infos
            </a>
          </div>
        </div>

        <div className="hidden lg:w-1/2 sm:block">
          <div className="flex items-center justify-center">
            <div className="embed-container ratio14x11">
              <iframe
                className="lazy"
                scrolling="no"
                src="/ani/faq/frame.htm"
                width="700"
                height="550"
                title="FAQ Animation"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default FaqSection
